// @flow

export const removeNullAndUndefinedProps = (obj: Object): Object => {
  return obj
    ? Object.keys(obj).reduce((acc, k) => {
        if (obj[k] !== null && obj[k] !== undefined && obj[k] !== "" && obj[k] !== "Invalid Date") {
          if (typeof obj[k] === "object" && !Array.isArray(obj[k])) {
            return { ...acc, [k]: removeNullAndUndefinedProps(obj[k]) };
          }

          if (Array.isArray(obj[k])) {
            return {
              ...acc,
              [k]: obj[k].map(d => {
                if (d && typeof d === "object") {
                  return removeNullAndUndefinedProps(d);
                }

                return d;
              }),
            };
          }

          return { ...acc, [k]: obj[k] };
        }

        return acc;
      }, {})
    : {};
};
